export default "__VITE_ASSET__Bzu1GXMu__"